import type { EduCourseTariff } from '@common/types/edu-course.type';
import type { Observable } from 'rxjs';
import type { EduCoursesTariffsCollectionState } from './edu-courses-tariffs.reducer';

import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as EduCoursesTariffsSelectors from './edu-courses-tariffs.selectors';

@Injectable()
export class EduCoursesTariffsCollectionFacade {
    private readonly store: Store<EduCoursesTariffsCollectionState> = inject(Store);

    public readonly eduCoursesTariffs$: Observable<EduCourseTariff[]> = this.store.select(
        EduCoursesTariffsSelectors.selectEduCoursesTariffs
    );
}
